import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "../../../../assets/scss/flashcard.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import x_mark from "../../../../assets/images/courses/group.svg";
import testBluePng from "../../../../assets/images/notes/notesModal.svg";
import Modal from "react-modal";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "60%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};

const AccountingFlashcard = (props) => {
    const history = useHistory();
    const location = useLocation();
    let array = location.state?.array;
    let getFlashCards = localStorage.getItem("getFlashcard");
    let isCreateTest = localStorage.getItem("isCreateTest");
    let flashcard_id = location.state?.flashcard_id;
    const isData = location.state?.isData;
    const notes = location.state?.notes;
    const noteData = location.state?.noteData;
    let flashCardData = JSON.parse(getFlashCards);
    const [loadingData, setLoadingData] = useState(true);
    const [countFlashcard, setCountFlashcard] = useState(0);
    const [question, setQuestion] = useState(array ? array[0]?.front : "");
    const [answer, setAnswer] = useState(array ? array[0]?.back : "");
    const [isFlip, setIsFlip] = useState(false);
    let isCreate = localStorage.getItem("isCreate");
    const [modalIsOpen, setIsOpen] = React.useState(false);
    let scoreResult;

    function score() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i].correct == true) {
                countRightAnswer = countRightAnswer + 1;
            }
        }
        let returnedData = JSON.stringify({
            questions_count: array.length,
            count_right_nswer: countRightAnswer,
            right_percentage:
                " (" +
                Math.floor((100 * countRightAnswer) / array.length) +
                "%)",
        });
        return returnedData;
    }

    function scoreNumber() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i].correct == true) {
                countRightAnswer = countRightAnswer + 1;
            }
        }
        return Math.floor((100 * countRightAnswer) / array.length);
    }

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    const createFlashcard = async () => {
        setLoadingData(false);
        let result;
        let flashId;

        let scoreData = score();
        let scoreDataNumber = scoreNumber();
        if (scoreData) {
            if (isCreate == "true") {
                result = await Repository.postRequest(
                    `api/flashcards/createFlashcards`,
                    {
                        ...flashCardData,
                        score: scoreDataNumber,
                        flashcard_name: noteData.title,
                    }
                );

                flashId = result.data.data?.flashcard_id;
            } else {
                result = await Repository.postRequest(
                    `api/flashcards/updateFlashcardScore`,
                    { id: flashcard_id, score: scoreDataNumber }
                );
                flashId = flashcard_id;
            }
            localStorage.setItem("isCreateTest", false);
        }
        setLoadingData(true);

        if (result?.status === 200 || result?.status === 201) {
            return {
                ...result,
                scoreResult: scoreDataNumber,
                flashId: flashId,
            };
        }
    };
    const nextFlashcard = async (item, isRight) => {
        setIsFlip(false);
        selectedAnswer(item, isRight);
        if (countFlashcard >= array.length - 1) {
            let result = await createFlashcard();

            scoreResult = result.scoreResult;
            let flashId = result.flashId;
            let flashcard_id = result.flashcard_id;

            if (result) {
                history.push({
                    pathname: "/resultFlashcard",
                    state: {
                        array,
                        isData,
                        flashcard_id,
                        noteData,
                        scoreResult,
                        flashId,
                    },
                });
            }
        } else {
            setCountFlashcard(countFlashcard + 1);
            setQuestion(array[countFlashcard + 1].front);
            setAnswer(array[countFlashcard + 1].back);
        }
    };
    const selectedAnswer = async (item, isRight) => {
        if (array[item].id === item && isRight == "correct") {
            array[item].correct = true;
            array[item].incorrect = false;
        } else {
            array[item].correct = false;
            array[item].incorrect = true;
        }
    };
    useEffect(async () => {
        if (isCreateTest) {
            await createFlashcard();
        }
        if (array == undefined) {
            history.push("/home");
        }
    }, []);
    return loadingData ? (
        <Card className="homeCard ">
            <div className="noteModalIcone">
                <img
                    src={testBluePng}
                    alt="testPng"
                    title="Click to see note"
                    onClick={() => {
                        openModal();
                    }}
                />
            </div>
            <div>
                <div
                    className="xmarkTest"
                    onClick={() => {
                        // history.push({
                        //     pathname: "/flashcards",
                        //     state: {
                        //         note_id,
                        //         notes,
                        //         noteData,
                        //         canDoIt,
                        //     },
                        // });
                        history.push({
                            pathname: "/home",
                        });
                    }}
                >
                    <img src={x_mark} alt="x_mark" />
                </div>
            </div>
            <div className="accountingHeaderContent mt-5">
                <h1 className=" mt-5">{flashCardData.flashcard_name}</h1>
                <p>Question {countFlashcard + 1 + "/" + array?.length} </p>
            </div>
            <div className=" accountingCardBody">
                <div>
                    <div className="nextBtnDivFlashcard">
                        <button
                            className="mt-2"
                            onClick={() => {
                                nextFlashcard(
                                    array[countFlashcard].id,
                                    "correct"
                                );
                            }}
                        >
                            Correct
                        </button>
                        <button
                            className="mt-2"
                            onClick={() => {
                                nextFlashcard(
                                    array[countFlashcard].id,
                                    "incorrect"
                                );
                            }}
                        >
                            Incorrect
                        </button>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div
                            className={
                                isFlip
                                    ? "answerBackground qwestionsContent"
                                    : "qwestionsContent"
                            }
                        >
                            {isFlip ? answer : question}
                            {isFlip ? (
                                <div className="answerContent">
                                    <span
                                        onClick={() => {
                                            setIsFlip(false);
                                        }}
                                    >
                                        Click to Question
                                    </span>
                                </div>
                            ) : (
                                <div className="answerContent">
                                    <span
                                        onClick={() => {
                                            setIsFlip(true);
                                        }}
                                    >
                                        Click to Flip
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Note</h2>
                    <img
                        src={x_mark}
                        onClick={closeModal}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <div>
                        <div
                            className="modalSpanNote"
                            dangerouslySetInnerHTML={{ __html: notes }}
                        />
                    </div>
                </div>
            </Modal>
        </Card>
    ) : (
        <Spinner spiner={true} />
    );
};

export default AccountingFlashcard;
